import styled from 'styled-components';

export const CompactNavigatorWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`;